import {
  Add,
  ArrowBack,
  DeleteOutlined,
  EditOutlined,
  FileUploadOutlined,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PreviewOutlined,
  PrintOutlined,
} from "@mui/icons-material";
import { ExcelIcon } from "assets/icons";
import { ChangeEventHandler } from "react";
import { XButton, XButtonProps } from "./x-button";
import { XIconButton, XIconButtonProps } from "./x-icon-button";

export const AddButton = (props: XButtonProps) => {
  return (
    <XButton {...props} variant="outlined" startIcon={<Add></Add>}>
      {props.children || `Thêm`}
    </XButton>
  );
};

export const EditButton = (props: XButtonProps) => {
  return (
    <XButton
      {...props}
      variant="outlined"
      startIcon={<EditOutlined></EditOutlined>}
    >
      {props.children || `Sửa`}
    </XButton>
  );
};

export const ExportExcelButton = (props: XButtonProps) => {
  return (
    <XButton {...props} variant="outlined" startIcon={<ExcelIcon></ExcelIcon>}>
      {props.children || `Xuất excel`}
    </XButton>
  );
};

type XUploadButtonProps = XButtonProps & {
  acceptFile?: string;
  multiple?: boolean;
  fileInputChanged?: ChangeEventHandler<HTMLInputElement>;
};
export const UploadButton = ({
  fileInputChanged,
  acceptFile,
  multiple = false,
  ...props
}: XUploadButtonProps) => {
  return (
    <XButton
      {...props}
      component="label"
      role={undefined}
      variant="outlined"
      startIcon={<FileUploadOutlined></FileUploadOutlined>}
    >
      {props.children || `Tải lên`}
      <input
        type="file"
        accept={acceptFile}
        multiple={multiple}
        style={{ display: "none" }}
        onChange={fileInputChanged}
      ></input>
    </XButton>
  );
};

export const RemoveButton = (props: XButtonProps) => {
  return (
    <XButton
      {...props}
      variant="text"
      color="error"
      startIcon={<DeleteOutlined></DeleteOutlined>}
    >
      {props.children || `Xóa`}
    </XButton>
  );
};

export const PrintPreviewButton = (props: XButtonProps) => {
  return (
    <XButton
      {...props}
      variant="outlined"
      startIcon={<PreviewOutlined></PreviewOutlined>}
    >
      {props.children || `Xem trước mẫu in`}
    </XButton>
  );
};

export const PrintButton = (props: XButtonProps) => {
  return (
    <XButton
      {...props}
      variant="outlined"
      startIcon={<PrintOutlined></PrintOutlined>}
    >
      {props.children || `In`}
    </XButton>
  );
};

export const EditIconButton = (props: XIconButtonProps) => {
  return (
    <XIconButton {...props} tooltipTitle={props.tooltipTitle || "Sửa"}>
      <EditOutlined fontSize="medium"></EditOutlined>
    </XIconButton>
  );
};

export const RemoveIconButton = (props: XIconButtonProps) => {
  return (
    <XIconButton {...props} tooltipTitle="Xóa">
      <DeleteOutlined fontSize="medium"></DeleteOutlined>
    </XIconButton>
  );
};

export const DetailIconButton = (props: XIconButtonProps) => {
  return (
    <XIconButton {...props} tooltipTitle="Chi tiết">
      <InfoOutlined fontSize="medium"></InfoOutlined>
    </XIconButton>
  );
};

export const GoBackIconButton = (props: XIconButtonProps) => {
  return (
    <XIconButton {...props} tooltipTitle="Quay lại">
      <ArrowBack fontSize="medium"></ArrowBack>
    </XIconButton>
  );
};
type ExpandButtonProps = XIconButtonProps & {
  open: boolean;
};
export const ExpandButton = ({ open, ...props }: ExpandButtonProps) => {
  return (
    <XIconButton {...props} tooltipTitle={open ? "Đóng" : "Mở"}>
      {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
    </XIconButton>
  );
};
